var _defs, _rect, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdekAsmartLogoNeg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "EDEKAsmart_logo_RGB",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 126.941,
    height: 115.591,
    viewBox: "0 0 126.941 115.591",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#radial-gradient);\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n    "), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.037,
    cy: 1.001,
    r: 0.756,
    gradientTransform: "translate(0.002 -0.053) scale(0.941 1.053)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#007fad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.005,
    stopColor: "#007fad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921,
    stopColor: "#0f3d62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10375b"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_22",
    "data-name": "Rechteck 22",
    className: "cls-1",
    width: 92.54,
    height: 87.082
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_13",
    "data-name": "Pfad 13",
    className: "cls-2",
    d: "M154.473,493.3H144v16.033h10.4a7.989,7.989,0,0,0,7.172-8.061,8.152,8.152,0,0,0-7.1-7.972m-1.244,11.729h-4.214v-7.35h4.214a3.776,3.776,0,0,1,3.491,3.669,3.856,3.856,0,0,1-3.491,3.681",
    transform: "translate(-125.72 -430.68)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_14",
    "data-name": "Pfad 14",
    className: "cls-2",
    d: "M0,493.3v16.033H15.233v-4.3H4.037v-1.7h11.2v-4.113H4.037v-1.7h11.2V493.3Z",
    transform: "translate(0 -430.68)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_15",
    "data-name": "Pfad 15",
    className: "cls-2",
    d: "M299.9,509.333h16.045v-4.3H304.736v-1.7h11.209v-4.113H304.736v-1.7h11.209V493.3H299.9Z",
    transform: "translate(-261.83 -430.68)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_16",
    "data-name": "Pfad 16",
    className: "cls-2",
    d: "M608.867,508.633h-3.846l-1.168-3.224h-6.271l-1.168,3.224H591.4l5.56-16.033H604.4l4.3,12.453v3.58Zm-6.271-6.982-1.79-5.1-1.79,5.1Z",
    transform: "translate(-516.327 -430.069)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_17",
    "data-name": "Pfad 17",
    className: "cls-2",
    d: "M467.4,493.3h-6.626l-5.636,6.093V493.3H450.2v15.944h4.938v-2.958l2.323-2.412,4.037,5.37h6.36l-6.817-9.14Z",
    transform: "translate(-393.051 -430.68)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_18",
    "data-name": "Pfad 18",
    className: "cls-2",
    d: "M476.325,667v3.757l-2.6.533V673.8l2.6-.533V679.9c0,3.313,1.612,4.659,4.57,4.037a6.911,6.911,0,0,0,2.691-1.168l-.812-2.323a3.875,3.875,0,0,1-1.7.812c-1.346.267-1.968-.444-1.968-1.879V672.75l3.948-.812v-2.513l-3.948.812V666.2Zm-13.43,6.372v13.976l2.78-.533v-7.528a4.51,4.51,0,0,1,3.58-4.57,2.788,2.788,0,0,1,2.323.356l1.257-2.78a4.446,4.446,0,0,0-3.313-.533,5.244,5.244,0,0,0-3.948,2.958l-.178-1.79Zm-10.13,4.291c5.827-1.168,5.827,8.15,0,9.229-2.425.444-4.392-.9-4.392-3.757a5.554,5.554,0,0,1,4.392-5.471m4.3-.978c-.812-1.434-2.691-1.968-4.57-1.612a8.49,8.49,0,0,0-6.982,8.594c0,4.748,2.958,6.8,6.893,6a6.887,6.887,0,0,0,4.659-3.491l.178,2.234,2.691-.533V673.905l-2.691.533Zm-22.659,16.122V685.1a4.283,4.283,0,0,1,3.313-4.392c1.967-.355,2.958,1.079,2.958,3.135v7.794l2.869-.533v-7.794c0-4.036-1.968-6.093-5.738-5.37a6.167,6.167,0,0,0-4.57,3.669,3.453,3.453,0,0,0-4.214-1.967,5.155,5.155,0,0,0-3.757,2.869l-.178-1.7-2.6.533V695.32l2.78-.533V686.9a4.3,4.3,0,0,1,3.224-4.392c1.968-.355,3.135,1.079,3.135,3.224v7.705Zm-14.7-9.584a6.087,6.087,0,0,0-5.192-.812c-2.513.444-5.56,2.234-5.56,5.281s2.958,3.4,5.458,3.135c1.968-.178,3.136.089,3.136,1.346,0,1.345-1.612,2.145-2.869,2.323a5.453,5.453,0,0,1-4.748-1.168L408.5,695.65c1.79,1.7,3.948,1.79,6.093,1.346,3.491-.711,5.738-2.958,5.738-5.56,0-3.58-3.224-3.491-5.738-3.313-1.7.178-2.869-.089-2.958-1.257,0-1.079,1.079-1.879,2.869-2.234a4.211,4.211,0,0,1,3.58.622Z",
    transform: "translate(-356.644 -581.632)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdekAsmartLogoNeg);
export default __webpack_public_path__ + "static/media/EDEKAsmart_logo_neg.675fe8766e7d4a33fd8b009b9a657c11.svg";
export { ForwardRef as ReactComponent };